export default {
  data() {
    return {
      exportExtraCasesExcelFields: [
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Bill To",
          value: "billing_type",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Date of Service(DOS)",
          value: "collection_date",
        },
        // {
        //   label: "Territory Manager",
        //   value: "hospital_marketers",
        // },
        {
          label: "Insurance Name",
          value: "billing_info.payor",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Ordering Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Policy No",
          value: "billing_info.policy_id",
        },
        {
          label: "Received Date",
          value: "received_date",
        },
        // {
        //   label: "Zip Extension",
        //   value: "patient_info.zip_extension",
        // },
        {
          label: "Status",
          value: "status",
        },
        {
          label: "Order Codes",
          value: "test_panel_id",
        },
        // {
        //   label: "Amendment Date",
        //   value: "amendement_details.amendment_time",
        // },
        // {
        //   label: "Amendment Reason",
        //   value: "amendement_details.amendment_revision_notes",
        // },
        // {
        //   label: "AR Notes",
        //   value: "ar_notes",
        // },
        // {
        //   label: "Assigned To",
        //   value: "test_performed_by.user",
        // },
        // {
        //   label: "Attachments Count",
        //   value: "attachments",
        // },
        // {
        //   label: "Attachments Exist",
        //   value: "attachments_count",
        // },
        {
          label: "Billing Status",
          value: "billing_status",
        },
        {
          label: "Billing Sub Status",
          value: "billing_sub_status",
        },
        {
          label: "CP Notes",
          value: "billing_status_notes",
        },
        // {
        //   label: "Billing Assigne",
        //   value: "billing_representative",
        // },
        {
          label: "Coding Notes",
          value: "billing_notes",
        },
        // {
        //   label: "Covid Status",
        //   value: "covid_status",
        // },
        {
          label: "CPT Codes",
          value: "cpt_coding_details",
        },
        {
          label: "CPT Codes Count",
          value: "cpt_coding_count",
        },
        {
          label: "CPT Exceptions",
          value: "cpt_exceptions",
        },
        {
          label: "CPT Exceptions Total",
          value: "cpt_exceptions_total",
        },
        {
          label: "CPT Total $",
          value: "cpt_coding_charges_final_sum",
        },
        {
          label: "Created Date",
          value: "created_at",
        },
        // {
        //   label: "EMR ID",
        //   value: "emr_reference_id",
        // },
        {
          label: "Finalized Date",
          value: "finalized_date",
        },
        // {
        //   label: "Hospice",
        //   value: "billing_info.hospice",
        // },
        {
          label: "ICD Codes",
          value: "icd_codes",
        },
        // {
        //   label: "ICD Code 1",
        //   value: "icd_10_codes[0]",
        // },
        // {
        //   label: "ICD Code 2",
        //   value: "icd_10_codes[1]",
        // },
        // {
        //   label: "ICD Code 3",
        //   value: "icd_10_codes[2]",
        // },
        // {
        //   label: "ICD Code 4",
        //   value: "icd_10_codes[3]",
        // },
        {
          label: "Individual Remaining Deductible Amount",
          value: "billing_info.individual_deductible_remaining",
        },
        // {
        //   label: "Insurance Eligibility",
        //   value: "insurance_eligibility_verified",
        // },
        // {
        //   label: "Insurance Discovery",
        //   value: "eligibity_verification_status",
        // },
        // {
        //   label: "Insurance Status",
        //   value: "billing_info.insurance_status",
        // },
        {
          label: "Insurance Carrier Code",
          value: "billing_info.insurance_carrier_code",
        },
        // {
        //   label: "Login User",
        //   value: "user",
        // },
        {
          label: "Order ID",
          value: "testgo_order_id",
        },
        {
          label: "Ordering Facility Phone",
          value: "hospital.phone",
        },
        {
          label: "Ordering Facility State",
          value: "hospital.state",
        },
        {
          label: "Patient Middle Name",
          value: "patient_info.middle_name",
        },
        {
          label: "Patient Gender",
          value: "patient_info.gender",
        },
        // {
        //   label: "Patient EMR",
        //   value: "patient_info.emr",
        // },
        {
          label: "Patient Phone",
          value: "patient_info.phone",
        },
        {
          label: "Patient Email",
          value: "patient_info.email",
        },
        {
          label: "Patient Address",
          value: "patient_info.address",
        },
        {
          label: "Plan Name",
          value: "insurance_eligibility_verified_details.foundCoverages[0].summary.name",
        },
        {
          label: "Plan Type",
          value:
            "insurance_eligibility_verified_details.foundCoverages[0].summary.planType",
        },
        {
          label: "Report Result Status",
          value: "report_result_status",
        },
        {
          label: "Sendout",
          value: "is_sendout",
        },
        {
          label: "Send Out Lab",
          value: "sendout.name",
        },
        // {
        //   label: "Skilled Nursing Facility",
        //   value: "billing_info.skilled_nursing_facility",
        // },
        // {
        //   label: "TAT",
        //   value: "TAT",
        // },
        // //for lab and facility users
        // {
        //   label: "Rejection Reason",
        //   value: "reasons",
        // },
        // //Added Actual Insurance in cases export
        // {
        //   label: "Actual Insurance",
        //   value: "actual_insurance",
        // },
        //for billing users
        // {
        //   label: "Rejection Reason",
        //   value: "billing_info.rejection_reason",
        // },
        // {
        //   label: "PECOS Status",
        //   value: "ordering_physician.pecos_status",
        // },
        // {
        //   label: "Enrolled Status",
        //   value: "ordering_physician.is_enrolled",
        // },
        // {
        //   label: "Completed Tests",
        //   value: "completed_tests",
        // },
        // {
        //   label: "Pending Tests",
        //   value: "pending_tests",
        // },
        // {
        //   label: "RXNT Sent On",
        //   value: "billing_application_sent_on",
        // },
        // {
        //   label: "RXNT Sent Type",
        //   value: "rxnt_moved_type",
        // },
        // {
        //   label: "Screening",
        //   value: "tox_screening",
        // },
        // {
        //   label: "Confirmation Count",
        //   value: "tox_tests_count",
        // },
        {
          label: "UTI Result",
          value: "uti_result",
        },
        {
          label: "Abr Result",
          value: "abr_result",
        },
        {
          label: "ABR Detected Tests",
          value: "abr_detected_names",
        },
        {
          label: "ABR Detected CPT",
          value: "abr_detected_cpt_codes",
        },
        // {
        //   label: "Sendout Result Status",
        //   value: "sendout_result.result_status",
        // },
        // {
        //   label: "Sendout Result Accession ID",
        //   value: "sendout_result.accession_id",
        // },
        // {
        //   label: "Sendout Result Billing Type",
        //   value: "sendout_result.billing_type",
        // },
        // {
        //   label: "Sendout Result Insurance Payor",
        //   value: "sendout_result.insurance_payor",
        // },
        // {
        //   label: "Insurance Uploaded",
        //   value: "is_insurance_uploaded",
        // },
        // {
        //   label: "Consistent Count",
        //   value: "consistent_count",
        // },
        // {
        //   label: "Inconsistent Count",
        //   value: "inconsistent_count",
        // },
        {
          label: "UTI High Detected",
          value: "uti_detected",
        },
        // {
        //   label: "Clinical Count",
        //   value: "clinical_count",
        // },
        {
          label: "Authorized By",
          value: "authorized_by",
        },
        {
          label: "Laboratory",
          value: "laboratory",
        },
        {
           label: "UTI Detected Tests",
          value: "uti_detected_tests",
        },
        {
          label: "UTI Detected CPT",
          value: "uti_detected_cpt_codes",
        }
      ],
      exportCasesExcelFields: [
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Bill To",
          value: "billing_type",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Date of Service(DOS)",
          value: "collection_date",
        },
        {
          label: "Insurance Name",
          value: "billing_info.payor",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Ordering Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Policy No",
          value: "billing_info.policy_id",
        },
        {
          label: "Received Date",
          value: "received_date",
        },
        {
          label: "Status",
          value: "status",
        },
        {
          label: "Amendment Date",
          value: "amendement_details.amendment_time",
        },
        {
          label: "Amendment Reason",
          value: "amendement_details.amendment_revision_notes",
        },
        {
          label: "Covid Status",
          value: "covid_status",
        },
        {
          label: "Created Date",
          value: "created_at",
        },
        {
          label: "Finalized Date",
          value: "finalized_date",
        },
        {
          label: "ICD Codes",
          value: "icd_codes",
        },
        {
          label: "Login User",
          value: "user",
        },
        {
          label: "Order ID",
          value: "order_id",
        },
        {
          label: "Ordering Facility Phone",
          value: "hospital.phone",
        },
        {
          label: "Patient Middle Name",
          value: "patient_info.middle_name",
        },

        {
          label: "Patient Gender",
          value: "patient_info.gender",
        },
        {
          label: "Patient EMR",
          value: "patient_info.emr",
        },
        {
          label: "Patient Phone",
          value: "patient_info.phone",
        },
        {
          label: "Patient Email",
          value: "patient_info.email",
        },
        {
          label: "Patient Address",
          value: "patient_info.address",
        },
        {
          label: "TAT",
          value: "TAT",
        },
      ],
      exportPhysiciansExcelFields: [
        {
          label: "NPI Number",
          value: "npi_code",
        },
        {
          label: "Name",
          value: "name",
        },
        {
          label: "Specializations",
          value: "specializations",
        },
        {
          label: "Phone",
          value: "phone",
        },
        {
          label: "Email",
          value: "email",
        },
        {
          label: "Address",
          value: "address",
        },
        {
          label: "Ordering Facilities",
          value: "hospitals",
        },
        {
          label: "PECOS Status",
          value: "pecos_status",
        },
      ],
      exportHospitalsExcelFields: [
        {
          label: "Ordering Facility Name",
          value: "name",
        },
        {
          label: "Ordering Facility Code",
          value: "code",
        },
        {
          label: "Ordering Facility Phone",
          value: "phone",
        },
        {
          label: "Ordering Facility Email",
          value: "email",
        },
        {
          label: "Ordering Facility Fax",
          value: "fax",
        },
        {
          label: "Ordering Facility Address",
          value: "address",
        },
        {
          label: "Ordering Facility NPI",
          value: "npi",
        },
        {
          label: "Date of Creation",
          value: "created_at",
        },
      ],
      exportSendOutsExcelFields: [
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },
        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },
        {
          label: "Patient Gender",
          value: "patient_info.gender",
        },
        {
          label: "Patient Phone",
          value: "patient_info.phone",
        },
        {
          label: "Patient Address",
          value: "patient_info.address",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Bill To",
          value: "billing_type",
        },
        {
          label: "Ordering Facility",
          value: "hospital.name",
        },
        {
          label: "Ordering Facility Phone",
          value: "hospital.phone",
        },
        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Ordering Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Collection Date",
          value: "collection_date",
        },
        {
          label: "Received Date ",
          value: "received_date",
        },
      ],
      defaultExportCasesExcelFields: [
        {
          label: "Accession ID",
          value: "accession_id",
        },
        {
          label: "Case Type",
          value: "case_types",
        },
        {
          label: "Bill To",
          value: "billing_type",
        },
        {
          label: "Patient First Name",
          value: "patient_info.first_name",
        },

        {
          label: "Patient Last Name",
          value: "patient_info.last_name",
        },
        {
          label: "Patient DOB",
          value: "patient_info.date_of_birth",
        },

        {
          label: "Ordering Facility",
          value: "hospital.name",
        },

        {
          label: "Ordering Physician",
          value: "ordering_physician.name",
        },
        {
          label: "Ordering Physician NPI",
          value: "ordering_physician.npi_code",
        },
        {
          label: "Date of Service(DOS)",
          value: "collection_date",
        },
        {
          label: "Insurance Name",
          value: "billing_info.payor",
        },
        {
          label: "Policy No",
          value: "billing_info.policy_id",
        },
        {
          label: "Received Date",
          value: "received_date",
        },
        {
          label: "Status",
          value: "status",
        },
        {
          label: "Order Code",
          value: "test_panel_id",
        },
        {
          label: "Territory Manager",
          value: "hospital_marketers",
        },
      ],
      exportMileageExcelFields: [
        {
          label: "Accession Id",
          value: "accession_id",
        },
        {
          label: "Residence Type",
          value: "residence_type",
        },
        {
          label: "Encore Miles",
          value: "encore_miles",
        },
        {
          label: "Technician",
          value: "technician",
        },
        {
          label: "Lab Drop off",
          value: "lab_drop_off_date",
        },
      ],
      groupBasedFields: {
        billingUsers: [
          "accession_id",
          "billing_type",
          "case_types",
          "collection_date",
          "hospital_marketers",
          "billing_info.payor",
          "hospital.name",
          "ordering_physician.name",
          "ordering_physician.npi_code",
          "patient_info.first_name",
          "patient_info.last_name",
          "patient_info.date_of_birth",
          "billing_info.policy_id",
          "received_date",
          "status",
          "test_panel_id",
          "amendement_details.amendment_time",
          "amendement_details.amendment_revision_notes",
          "ar_notes",
          "test_performed_by.user",
          "attachments",
          "attachments_count",
          "billing_status",
          "billing_sub_status",
          "billing_status_notes",
          "billing_representative",
          "billing_notes",
          "covid_status",
          "cpt_coding_details",
          "created_at",
          "emr_reference_id",
          "finalized_date",
          "icd_codes",
          "billing_info.individual_deductible_remaining",
          "user",
          "hospital_branch.display_name",
          "order_id",
          "hospital.phone",
          "hospital.state",
          "patient_info.middle_name",
          "patient_info.gender",
          "patient_info.emr",
          "patient_info.phone",
          "patient_info.email",
          "patient_info.address",
          "patient_info.zip_extension",
          "billing_info.waveland_plan_name",
          "patient_info.pregnant",
          "insurance_eligibility_verified_details.foundCoverages[0].summary.planType",
          "insurance_eligibility_verified_details.foundCoverages[0].summary.name",
          "report_result_status",
          "specimen_collector",
          "is_sendout",
          "TAT",
          "sendout.name",
          "insurance_eligibility_verified",
          "billing_info.insurance_status",
          "billing_info.insurance_carrier_code",
          "billing_info.rejection_reason",
          "ordering_physician.pecos_status",
          "ordering_physician.is_enrolled",
          "billing_info.hospice",
          "billing_info.skilled_nursing_facility",
          "billing_application_sent_on",
          "rxnt_moved_type",
          "tox_screening",
          "tox_tests_count",
          "uti_result",
          "abr_result",
          "sendout_result.result_status",
          "sendout_result.accession_id",
          "sendout_result.billing_type",
          "sendout_result.insurance_payor",
          "is_insurance_uploaded",
          "consistent_count",
          "inconsistent_count",
          "clinical_count",
          "eligibity_verification_status",
          "cpt_coding_count",
          "icd_10_codes[0]",
          "icd_10_codes[1]",
          "icd_10_codes[2]",
          "icd_10_codes[3]",
          "abr_detected_names",
          "abr_detected_cpt_codes",
          "cpt_exceptions",
          "cpt_exceptions_total",
          "cpt_coding_charges_final_sum",
          "authorized_by",
          "laboratory",
          "uti_detected_tests",
          "uti_detected_cpt_codes",
        ],
        labUsers: [
          "accession_id",
          "billing_type",
          "case_types",
          "collection_date",
          "billing_info.payor",
          "hospital.name",
          "ordering_physician.name",
          "ordering_physician.npi_code",
          "patient_info.first_name",
          "patient_info.last_name",
          "patient_info.date_of_birth",
          "billing_info.policy_id",
          "received_date",
          "status",
          "test_panel_id",
          "hospital_marketers",
          "amendement_details.amendment_time",
          "amendement_details.amendment_revision_notes",
          "attachments",
          "attachments_count",
          "covid_status",
          "created_at",
          "emr_reference_id",
          "finalized_date",
          "icd_codes",
          "order_id",
          "patient_info.middle_name",
          "patient_info.gender",
          "patient_info.phone",
          "patient_info.address",
          "report_result_status",
          "is_sendout",
          "TAT",
          "reasons",
          "ordering_physician.pecos_status",
          "ordering_physician.is_enrolled",
          "completed_tests",
          "pending_tests",
          "actual_insurance",
          "uti_detected",
        ],
        facilityUsers: [
          "accession_id",
          "billing_type",
          "case_types",
          "collection_date",
          "billing_info.payor",
          "hospital.name",
          "ordering_physician.name",
          "ordering_physician.npi_code",
          "patient_info.first_name",
          "patient_info.last_name",
          "patient_info.date_of_birth",
          "billing_info.policy_id",
          "received_date",
          "status",
          "test_panel_id",
          "amendement_details.amendment_time",
          "amendement_details.amendment_revision_notes",
          "covid_status",
          "created_at",
          "emr_reference_id",
          "finalized_date",
          "hospital_branch.display_name",
          "order_id",
          "hospital.phone",
          "hospital.state",
          "patient_info.middle_name",
          "patient_info.gender",
          "patient_info.emr",
          "patient_info.phone",
          "patient_info.email",
          "patient_info.address",
          "billing_info.waveland_plan_name",
          "patient_info.pregnant",
          "report_result_status",
          "TAT",
          "reasons",
          "ordering_physician.pecos_status",
          "ordering_physician.is_enrolled",
        ],
      },
    }
  },
}
